export type Spacing =
  | '0'
  | '0_1'
  | '0_25'
  | '0_5'
  | '0_75'
  | '1'
  | '1_5'
  | '2'
  | '2_5'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10';

export const spacing: Record<Spacing, string> = {
  '0': '0rem',
  '0_1': '0.1rem',
  '0_25': '0.2rem',
  '0_5': '0.4rem',
  '0_75': '0.8rem',
  '1': '1.2rem',
  '1_5': '1.6rem',
  '2': '2rem',
  '2_5': '2.4rem',
  '3': '2.8rem',
  '4': '3.2rem',
  '5': '4rem',
  '6': '4.8rem',
  '7': '5.6rem',
  '8': '6.4rem',
  '9': '7.2rem',
  '10': '8rem',
};
